import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import ru from "vuetify/es5/locale/ru";
import en from "vuetify/es5/locale/en";
import zh from "vuetify/es5/locale/zh-Hans";
import { detectLocale } from "@/plugins/i18n";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: "#00c5ff",
        accent: "#00c5ff"
      }
    }
  },
  iconfont: "md",
  lang: {
    locales: {
      ru,
      en,
      zh
    },
    current: detectLocale()
  }
};

export default new Vuetify(opts);
